export class AutomatedMessage {
    constructor(id, lang, trigger, text, coach) {
        this.id = id;
        this.lang = lang;
        this.trigger = trigger;
        this.text = text;
        this.coach = coach;
    }
}
